(ns teamoesterreich.admin-mode.lebensretter.lr-user.toe-last-changed
  (:require ["react-virtualized" :as rv]
            [clojure.string]
            [reagent-material-ui.components :as mui]
            [goog.date.DateTime]
            [teamoesterreich.view-state :as v-state]
            [teamoesterreich.admin-mode.data.logs :as d-logs]
            [teamoesterreich.admin-mode.data.organisation :as d-organisation]
            [reagent.core :as r]
            [teamoesterreich.util.log :as log]
            [teamoesterreich.util.helper :as h]
            [teamoesterreich.util.date :as h-date]
            [teamoesterreich.admin-mode.ui-helper.preview-modal :as preview-modal]
            [teamoesterreich.admin-mode.actions :as a]
            [reagent-material-ui.icons.edit :as ic-edit]
            [reagent-material-ui.icons.email :refer [email]]
            [reagent-material-ui.icons.speaker-notes :refer [speaker-notes]]
            ))



(defonce LINE-HEIGHT 60)

(defn get-data-by-tomId [tomId]
  (let [!entry (r/cursor v-state/app-state [:lr-list :data "elms" (str tomId)])]
    (or @!entry
        {:index tomId :tomId "ERROR"})))



(defn filter-fn [rows search]
  ;;(println "filter-fn " (count rows) search)
  (filter (fn [e]
            (re-find
              (re-pattern (reduce (fn [c e] (str c "(?=.*" e ")")) "(?i)^" (clojure.string/split search " ")))
              (str (:user-tomId e) "#" (:user-firstName e) "#" (:user-lastName e) "#" (:user-email e) "#" (:user-phoneNumber e))))
          rows))



(defn select-renderer [!st-selected]
  (fn [js-parm]
    (r/as-element
      (let [{rowData "rowData"} (js->clj js-parm)
            tomId (get rowData "tomId")]
        [:div
         [mui/checkbox
          {:onChange (fn [_ val]
                       (log/debug ":onChange" tomId val (clj->js @!st-selected))
                       (if (coll? @!st-selected)
                         (swap! !st-selected assoc tomId val)
                         (reset! !st-selected {tomId val})))
           :checked  (if (get-in @!st-selected [tomId]) true false)
           }]]

        ))))

(defn email-cell-renderer [!cursor]
  (fn [js-parm]
    (let [{rowData "rowData" rowIndex "rowIndex"} (js->clj js-parm)
          tomId (get rowData "tomId")]
      (r/as-element
        [mui/icon-button {:label   "Email senden"
                          :title   "Email senden"
                          :onClick (fn []
                                     (reset! !cursor tomId)
                                     (swap! v-state/app-state assoc-in [:toe-map :activeSendMail] tomId))
                          } [email {:fontSize "small"}]]))))

(defn correspondence-cell-renderer [!show-correspondence-modal !cursor]
  (fn [js-parm]
    (let [{rowData "rowData" rowIndex "rowIndex"} (js->clj js-parm)
          tomId (get rowData "tomId")]
      ;(log/debug "correspondence-cell-renderer" (js->clj js-parm))
      (r/as-element
        [mui/icon-button {:label   "Korrespondenz"
                          :title   "Korrespondenz"
                          :onClick (fn []
                                     (reset! !cursor tomId)
                                     (reset! !show-correspondence-modal tomId))
                          } [speaker-notes {:fontSize "small"}]]))))

(defn org-renderer [dst-list]
  (fn [js-parm]
    (let [{rowData "rowData"} (js->clj js-parm)
          cell-data (get rowData "orgId")]
      ;(js/console.log "rowData" (clj->js (get rowData "orgId")))
      (r/as-element
        [:span (or (get dst-list cell-data) (str "" cell-data))]))))

(defn edit-cell-renderer [js-parm]
  (let [{cell-data "cellData"} (js->clj js-parm)]
    (r/as-element
      [mui/icon-button {:label   "bearbeiten"
                        :title   "bearbeiten"
                        :onClick (fn []
                                   (log/debug "action edit-cell-renderer : " cell-data)
                                   (a/open-lr-user-view cell-data))
                        } [ic-edit/edit {:fontSize "small"}]])))


(defn date-renderer [js-parm]
  (let [{cell-data "cellData"} (js->clj js-parm)
        ;l-date (date-h/parse-local-date cell-data)
        ]
    ;(js/console.log l-date)
    (r/as-element
      [:span (if (> (count cell-data) 10)
               (str (subs cell-data 6 8) "." (subs cell-data 4 6) "." (subs cell-data 0 4))
               "-")])))

(defn datetime-renderer [js-parm]
  (let [{cell-data "cellData"} (js->clj js-parm)
        l-date (h-date/parse-http! cell-data)
        ]
    (r/as-element
      [:div (if l-date
              [:span (h-date/print-google-date l-date)]
              "-")])))


;(in-ns 'teamoesterreich.admin-mode.lebensretter.lr-user.toe-last_changed)

(defn inside-table [!st rows]
  (fn [m]
    (let [width (aget m "width")
          height (aget m "height")
          ;!invalidated (r/cursor !st [:log-invalidated])
          !sort (r/cursor !st [:sort])
          !reverse (r/cursor !st [:reverse])
          !cursor (r/cursor v-state/app-state [:lr-list :cursor])
          !st-selected (r/cursor v-state/app-state [:lr-list :selected])

          _ (d-organisation/get-store-organisations)
          !organisations (r/cursor v-state/app-state [:organisations])
          dst-list (reduce (fn [c [k v]] (assoc c k v)) {} (d-organisation/get-dest-list @!organisations))

          cursorIndex (reduce (fn [c {tomId :tomId i :index}] (if (= @!cursor tomId) i c)) 0 rows)
          ]
      (log/debug "Log Table Data" (clj->js rows))
      (r/as-element
        [:> rv/Table
         {:headerHeight    50
          :height          (- height 70)
          :rowCount        (count rows)
          :rowGetter       (fn [i]
                             ;(println (str "rowGet " (aget i "index")))
                             (clj->js (nth rows (aget i "index"))))
          :rowClassName    (fn [i] (when (odd? (aget i "index")) "table-odd"))
          :sort            (fn [s] (swap! !st assoc :sort (aget s "sortBy") :reverse (= "DESC" (aget s "sortDirection"))))
          :sortBy          @!sort
          :sortDirection   (if @!reverse "DESC" "ASC")
          :rowHeight       45
          :width           width
          :headerClassName "headerColumn"
          :className       "LebensretterLastChangedList"}

         [:> rv/Column
          {:label        (r/as-element [mui/checkbox {:disabled true}])
           :dataKey      "tomId"
           :disableSort  true
           :className    "bordered exampleColumn"
           :cellRenderer (select-renderer !st-selected)
           :width        70} [:a {:href ""}]]

         [:> rv/Column
          {:label        (r/as-element [ic-edit/edit])
           :disableSort  true
           :dataKey      "tomId"
           :className    "bordered exampleColumn"
           :cellRenderer edit-cell-renderer
           :width        40}]


         [:> rv/Column
          {:label     "TomId"
           :dataKey   (name :tomId)
           :style     {:textAlign "left" :overflow "hidden"}
           :className "bordered exampleColumn"
           :width     50}]



         [:> rv/Column
          {:label        "Zeit"
           :dataKey      (name :date)
           :style        {:textAlign "left" :overflow "hidden"}
           :className    "bordered exampleColumn"
           :cellRenderer datetime-renderer
           :width        120}]

         [:> rv/Column
          {:label     "Vorname"
           :dataKey   (name :user-firstName)
           :style     {:textAlign "left" :overflow "hidden"}
           :className "bordered exampleColumn"
           :width     120}]

         [:> rv/Column
          {:label     "Nachname"
           :dataKey   (name :user-lastName)
           :style     {:textAlign "left" :overflow "hidden"}
           :className "bordered exampleColumn"
           :width     120}]
         ;

         [:> rv/Column
          {:label        "Dienststelle"
           :dataKey      (name :orgId)
           :className    "bordered exampleColumn"
           :cellRenderer (org-renderer dst-list)
           :width        120}]

         [:> rv/Column
          {:label     "Aktion"
           :dataKey   (name :message)
           :className "bordered exampleColumn"
           :style     {:textAlign "left" :overflow "hidden"}
           :width     380
           }]

         ]))))

(defn preview-modal [!selected-document !show-preview]
  [preview-modal/modal @!selected-document !show-preview])


(defn table [!st rows]
  (let [
        !st-selected (r/cursor v-state/app-state [:lr-list :selected])
        !cursor (r/cursor v-state/app-state [:lr-list :cursor])
        !show-preview (r/cursor !st [:show-preview])
        !selected-document (r/cursor !st [:selected-document])
        ]
    (fn []
      [:div
       [preview-modal !selected-document !show-preview]
       [:> rv/AutoSizer
        {:style         {:height "100%"}
         :data-cursor   (str @!cursor)
         :data-selected (str @!st-selected)}
        (inside-table !st rows)]
       ])))


(defn filter-logs [elms search sort reverse_]
  (let [rows (if elms (into [] (map-indexed (fn [idx [_ l]] {:index          (inc idx)
                                                             :uuid           (:log-uuid l)
                                                             :user-firstName (str (get-in l [:log-user :user-firstName]))
                                                             :user-lastName  (str (get-in l [:log-user :user-lastName]))
                                                             :tomId          (get-in l [:log-user :user-tomId])
                                                             :orgId          (get-in l [:log-user :user-orgId])
                                                             :date           (get-in l [:log-date])
                                                             :message        (get-in l [:log-message])
                                                             }) elms)) [])
        rows (sort-by (fn [e] (get e (or sort :date))) rows)
        rows (if (or (nil? reverse_) (true? reverse_)) (reverse rows) rows)
        ]
    rows))



(defn update-list [!st]
  (let [!data (r/cursor !st [:log-data])
        !search (r/cursor !st [:search])
        !sort (r/cursor !st [:sort-reverse])
        !reverse (r/cursor !st [:log-reverse])
        !loaded (r/cursor !st [:log-loaded])
        !invalidated (r/cursor !st [:invalidated])
        ]
    (log/debug "update-log-list " (clj->js @!search) (clj->js @!sort) " ... " @!invalidated " [[ " (clj->js @!data))
    (if-not (and @!loaded @!invalidated)
      (d-logs/<get-admin-log-list
        (fn [data]
          (let [r-data (filter-logs data @!search @!sort @!reverse)]
            (swap! !st assoc
                   :log-data data
                   :log-loaded true
                   :invalidated false
                   :log-count (count r-data)
                   :log-rows r-data)))
        )
      (let [r-data (filter-logs @!data @!search @!sort @!reverse)]
        (swap! !st assoc
               :log-count (count r-data)
               :invalidated false
               :log-rows r-data))
      )))

(defn table-column [!st]
  (let [
        !rows (r/cursor !st [:log-rows])
        !loaded (r/cursor !st [:log-loaded])
        !invalidated (r/cursor !st [:invalidated])
        cnt-rows (count @!rows)]
    (when (or (not @!loaded) @!invalidated) (update-list !st))
    (cond
      (not @!loaded) [:div
                      [mui/circular-progress {:variant_ "determinate" :color_ "secondary" :size 40 :style {:marginTop "40px"}}]
                      [mui/typography {} "Lade Daten ... "]
                      ]

      (and @!loaded (> cnt-rows 0))
      [(table !st @!rows)]

      :else
      [:h3 "Keine Ergebnisse gefunden!"])
    ))








